export default __webpack_public_path__ + "static/media/two.5b75772f.jpg";